import { useParams } from "react-router-dom";

import ProjectsList from "./List.jsx";
import ProjectsDetail from "./Detail.jsx";

const ProjectsPage = () => {
    const { secondParam } = useParams();

    const Specified = secondParam ? ProjectsDetail : ProjectsList;

    return <Specified />;
};

export default ProjectsPage;
